import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { VueQueryPlugin } from '@tanstack/vue-query'
import App from './App.vue'
import router from './router'
import './assets/css/main.css'
import { initOidc } from '@/plugins/oidc'

const app = createApp(App)

app.use(createPinia())
app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000,
        retry: 1,
      },
    },
  },
})

// Initialize OIDC before installing router to prevent auth guard race condition.
// The router guard checks isAuthenticated, so OIDC must restore the user session first.
initOidc()
  .then(() => {
    app.use(router)
    app.mount('#app')
  })
  .catch((err) => {
    console.error('OIDC initialization failed:', err)
    app.use(router)
    app.mount('#app')
  })